import { ArchiveMusicIcon } from './ArchiveMusicIcon';

/**
 * author: Colton Wiscombe
 * id 30D759AA-6F1F-463A-9768-8D92F607207F
 * name archive-music
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/archive-music.svg
 * tags
 * - Music 
 */
export const BoxMusicIcon = ArchiveMusicIcon;
export default BoxMusicIcon